/* eslint-disable linebreak-style */
/** Video Carousel functionality */

// ensure the main object is defined
if (typeof(so) === 'undefined') {
    var so = {};
}

// Video carousel module
so.videoCarousel = {
    init: function() {
        this.initCarousels();
    },

    initCarousels: function() {
        // Handle multiple video carousel instances on the same page
        $('.element-careers-video-carousel').each(function() {
            var $container = $(this);
            var $swiperContainer = $container.find('.careers-video-swiper');
            var $prevBtn = $container.find('.carousel-prev');
            var $nextBtn = $container.find('.carousel-next');

            // Exit if no swiper container or Swiper is not available
            if ($swiperContainer.length === 0 || typeof Swiper === 'undefined') {
                return;
            }

            // Initialize Swiper
            var swiper = new Swiper($swiperContainer[0], {
                slidesPerView: 1,
                spaceBetween: 20,
                centeredSlides: false,
                loop: false,
                grabCursor: true,
                watchOverflow: true,

                // Responsive breakpoints
                breakpoints: {
                    992: {
                        slidesPerView: 1.2,
                        spaceBetween: 20,
                    },
                    1400: {
                        slidesPerView: 1.6,
                        spaceBetween: 20,
                    },
                    2000: {
                        slidesPerView: 2.2,
                        spaceBetween: 20,
                    },
                },

                // Navigation
                navigation: {
                    nextEl: $nextBtn[0],
                    prevEl: $prevBtn[0],
                },

                // Pagination
                pagination: {
                    el: $container.find('.carousel-indicator')[0],
                    bulletClass: 'slide-indicator',
                    bulletActiveClass: 'active',
                },

                // Accessibility
                a11y: {
                    prevSlideMessage: 'Previous video',
                    nextSlideMessage: 'Next video',
                    slideLabelMessage: 'Video {{index}} of {{slidesLength}}',
                },
            });

            // Play button click handlers for future lightbox implementation
            $container.find('.play-button').on('click', function() {
                var videoUrl = $(this).data('video-url');
                if (videoUrl) {
                    // Placeholder for future lightbox implementation
                    console.log('Video URL:', videoUrl);
                    // TODO: Implement lightbox functionality
                }
            });

            // Store swiper instance for potential future use
            $swiperContainer.data('swiper', swiper);
        });
    },
};

$(document).ready(function () {
    so.videoCarousel.init();
});